import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react'

/**
 * Cabecera de columna ordenable de TRES estados (sin orden → ascendente → descendente → sin orden), con la flecha del orden
 * actual y `aria-sort` para lectores de pantalla. El ciclo lo lleva quien la usa (`onSort`). Se usa casi siempre a través de
 * `useTableSort` (`lib/useTableSort`), que lleva el orden, el ciclo y la URL; `SortableTh` (de dos estados) es la de
 * «Oportunidades».
 */
export default function ColumnSortTh({
  sortKey,
  label,
  align,
  active,
  dir,
  onSort,
  ariaLabel,
  className = 'px-3 py-2',
  caps = true,
}: {
  sortKey: string
  label: string
  align: 'left' | 'right' | 'center'
  active: boolean
  dir: 'asc' | 'desc'
  onSort: (key: string) => void
  ariaLabel: string
  /** Relleno y tipografía de la celda de cabecera: cada tabla tiene los suyos (por defecto, los de Emitidas). */
  className?: string
  /** Cabecera en MAYÚSCULAS con el espaciado ancho (lo habitual); `false` la deja como la escribió la tabla. */
  caps?: boolean
}) {
  const Icon = !active ? ArrowUpDown : dir === 'asc' ? ArrowUp : ArrowDown
  return (
    <th
      className={`${className} text-${align}`}
      aria-sort={active ? (dir === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <button
        type="button"
        onClick={() => onSort(sortKey)}
        aria-label={ariaLabel}
        className={`inline-flex items-center gap-1 ${caps ? 'uppercase tracking-wider' : ''} hover:t-primary ${
          active ? 't-primary' : ''
        } ${align === 'right' ? 'flex-row-reverse' : ''}`}
        data-testid={`sort-${sortKey}`}
      >
        {label}
        <Icon size={11} className={active ? 'text-jr2-600 dark:text-jr2-300' : 't-faint'} />
      </button>
    </th>
  )
}
